<mat-card fxLayoutGap class="p-3 d-flex gap-3">
  <div class="fw-semibold fs-4">{{teacherCertificationId ? 'Modifica Abilitazione' : 'Nuova Abilitazione'}}</div>
  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <div class="w-100 d-flex flex-row gap-3">
      <div class="flex-grow-1">
        <app-dea-label class="mb-2" [label]="'Anno ottenimento abilitazione:'"></app-dea-label>
        <input formControlName="year" type="text" class="form-control dea-form-input" justInt max="9999" min="1000"
          minlength="4" maxlength="4" />
      </div>
    </div>
    <div class="w-100 d-flex flex-row gap-3">
      <div class="flex-grow-1">
        <div class="d-flex flex-row gap-3 justify-content-between align-items-center mb-2">
          <app-dea-label [label]="'Classi di concorso: (Opzionale)'"></app-dea-label>
          <app-dea-fast-action-btn class="ms-auto" (click)="openSubjectsDialog()">
            Aggiungi Materia
          </app-dea-fast-action-btn>
        </div>
        <div formArrayName="teaching_subjects" class="rounded p-2 d-flex flex-column gap-2"
          [ngClass]="{'border': teachingSubjectsArray.controls.length > 0}"
          style="max-height: 30vh; overflow-y: scroll;">
          <div *ngFor="let subjectGroup of teachingSubjectsArray.controls; let i = index" [formGroupName]="i"
            class="d-flex justify-content-between align-items-center border rounded p-2">
            <div class="hstack gap-2">
              <strong>{{ subjectGroup.get('dea_id')?.value }}</strong>
              <div class="vr my-auto" style="height: 2rem !important;"></div>
              {{ subjectGroup.get('nome')?.value }}
            </div>
            <button class="d-flex align-items-center dea-icon-btn" mat-icon-button aria-label="Elimina Materia"
              title="Elimina Materia" (click)="removeSubjectById(subjectGroup.get('_id')?.value)">
              <i class="bi bi-trash3 dea-icon-btn text-danger" style="opacity: 1;"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100">
      <app-dea-label [label]="'Allegato: (Opzionale)'"></app-dea-label>
      <div>
        <input type="file" accept="image/png,image/jpeg,.pdf" class="form-control dea-form-input mb-1"
          placeholder="Seleziona un file" (change)="onFileChange($event)" />
        <div class="fw-lighter fs-055r">Formati accettati: PDF - PNG/JPG/JPEG</div>
      </div>
    </div>
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Descrizione: (Opzionale)'"></app-dea-label>
      <textarea formControlName="description" class="form-control dea-form-input" rows="2"
        style="max-height: 80px !important;">
      </textarea>
    </div>
  </form>
  <div *ngIf="error" class="fs-075r text-danger">{{error.message}}</div>
  <div class="m-0 p-0 gap-2" mat-dialog-actions align="end">
    <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">Annulla</button>
    <button *ngIf="!isPosting" class="px-5 py-1" mat-flat-button color="primary" (click)="onConfirm()">
      Salva
    </button>
    <button *ngIf="isPosting" class="px-5 py-1" mat-flat-button disabled>
      <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon> Caricamento
    </button>
  </div>
</mat-card>